import { render, staticRenderFns } from "./AzrCharSheetAbilityComponent.vue?vue&type=template&id=4844de22&scoped=true"
import script from "./AzrCharSheetAbilityComponent.vue?vue&type=script&lang=ts"
export * from "./AzrCharSheetAbilityComponent.vue?vue&type=script&lang=ts"
import style0 from "./AzrCharSheetAbilityComponent.vue?vue&type=style&index=0&id=4844de22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844de22",
  null
  
)

export default component.exports